"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderRTEPlaceholderForOolibPreview = void 0;
var react_1 = __importDefault(require("react"));
var Tooltip_1 = require("../components/Tooltip");
var themes_1 = require("../themes");
var renderRTEPlaceholderForOolibPreview = function (options) {
    if (options === void 0) { options = {}; }
    var _a = options.width, width = _a === void 0 ? "2rem" : _a, _b = options.height, height = _b === void 0 ? "2rem" : _b, _c = options.tooltipPos, tooltipPos = _c === void 0 ? "bottom" : _c;
    return (react_1.default.createElement("div", { style: {
            width: width,
            height: height,
            background: themes_1.colors.lightRed,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flex: "0 0 auto",
        } },
        react_1.default.createElement(Tooltip_1.Tooltip, { popOutOfOverflowHiddenParent: true, position: tooltipPos, text: "RichTextEditor component needs to be provided via theme provider in order to render it", presetTarget: "infoIcon" })));
};
exports.renderRTEPlaceholderForOolibPreview = renderRTEPlaceholderForOolibPreview;
